/* Start — học viên chọn bắt đầu từ đâu trong lớp. */
import { Link } from "react-router-dom"
import { motion, useReducedMotion } from "framer-motion"
import { Card, CardContent } from "@/components/ui/card"
import { Icon, type AnyIconName } from "@/components/icon"
import { Page, PageHeader, usePageTitle } from "@/components/page"
import { EditorialVisual } from "@/components/simba"
import { useClass } from "@/app/ClassLayout"

const PATHS: { id: string; title: string; description: string; icon: AnyIconName }[] = [
  { id: "onboarding", title: "Get Started", description: "Làm quen với lớp học và hoàn thành các bước đầu tiên.", icon: "flame" },
  { id: "discover", title: "Key Concepts", description: "Khám phá những ý tưởng quan trọng bằng ví dụ và quiz ngắn.", icon: "lightbulb" },
  { id: "reflections", title: "4F Reflection", description: "Nhìn lại trải nghiệm học tập và biến điều đã học thành hành động.", icon: "notebook" },
]

export default function StartPage() {
  const { base, data } = useClass()
  const course = data.class || {}
  const reduce = useReducedMotion()
  usePageTitle(`Start · ${course.course_name || "Lớp học"}`, "Chọn nơi bắt đầu trong lớp học Simba.")

  return (
    <Page>
      <div className="grid items-center gap-8 lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)]">
        <div className="flex flex-col gap-6">
          <PageHeader eyebrow={course.course_name} title="Start" description="Con muốn bắt đầu từ đâu?" />
          <motion.ul
            className="flex flex-col gap-3"
            initial={reduce ? false : "hidden"}
            animate="shown"
            variants={{ hidden: {}, shown: { transition: { staggerChildren: 0.06 } } }}
          >
            {PATHS.map((path) => (
              <motion.li key={path.id} variants={{ hidden: reduce ? {} : { y: 8 }, shown: { y: 0 } }}>
                <Link to={`${base}/${path.id}`} className="group block">
                  <Card size="sm" className="transition-[transform,box-shadow] group-hover:-translate-y-0.5 group-hover:shadow-card-hover">
                    <CardContent className="flex items-center gap-4">
                      <span className="grid size-12 shrink-0 place-items-center rounded-2xl bg-soft">
                        <Icon name={path.icon} className="size-6 text-orange-strong" />
                      </span>
                      <span className="min-w-0 flex-1">
                        <span className="block font-heading text-lg font-semibold text-ink">{path.title}</span>
                        <span className="block text-sm text-muted-foreground">{path.description}</span>
                      </span>
                      <Icon name="arrow-right" className="size-5 transition-transform group-hover:translate-x-1" />
                    </CardContent>
                  </Card>
                </Link>
              </motion.li>
            ))}
          </motion.ul>
        </div>
        <EditorialVisual kind="journey" alt="Hành trình học tập cùng Sư Tử Con" priority className="hidden lg:block" />
      </div>
    </Page>
  )
}
